import req from "@/utils/axios.js";
 const ossurl = import.meta.env.VITE_OSS_URL;
export default {
    //检查图片地址
    getImageUrl(url) {
      if (!url) return '';
      // 检查是否已经有http或https前缀
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 如果没有前缀，添加oss域名
      return ossurl + url;
    },
}